import {combineReducers} from "redux";

// import reducers
import auth from "./auth";
import utils from "./utils";
import languages from "./languages";
import moderators from "./moderators";
import staticTexts from "./staticTexts";
import media from "./media";
import composite from "./composite";
import slider from "./slider";
import banner from "./banner";
import customPages from "./customPages";
import general from "./general";
import about from "./about";
import blogs from "./blogs";
import subscribers from "./subscribers";
import menu from "./menu";
import advertisement from "./advertisement";


export default combineReducers({
    about,
    auth,
    utils,
    languages,
    media,
    composite,
    moderators,
    staticTexts,
    slider,
    banner,
    customPages,
    general,
    blogs,
    subscribers,
    menu,
    advertisement,
});
